import React from 'react';

const Row = ({ label, value, highlight, note }) => (
  <div className={`flex items-center justify-between py-1.5 border-b border-[rgba(101,141,113,0.2)] last:border-0 ${highlight ? 'bg-[rgba(216,206,179,0.04)] px-1' : ''}`}>
    <div className="flex flex-col">
      <span className="text-[10px] uppercase tracking-widest text-[#a9c9b1] font-bold">{label}</span>
      {note && <span className="text-[8px] text-[#658d71]">{note}</span>}
    </div>
    <span className={`text-sm font-black tabular-nums ${highlight ? 'text-[#d8ceb3]' : 'text-white'}`}>{value ?? '--'}</span>
  </div>
);

const PlayerMetricsSeasonStats = ({ metrics, profile, isPitcher }) => {
  const year = new Date().getFullYear();
  const seasonHitting = metrics?.season?.stats?.find(s => s.group?.displayName === 'hitting')?.splits?.[0]?.stat;
  const seasonPitching = metrics?.season?.stats?.find(s => s.group?.displayName === 'pitching')?.splits?.[0]?.stat;
  const careerHitting = profile?.hitting;
  const careerPitching = profile?.pitching;

  const hitting = seasonHitting || careerHitting;
  const pitching = seasonPitching || careerPitching;
  const label = seasonHitting || seasonPitching ? `${year} Season` : 'Career';

  return (
    <div className="flex flex-col gap-4">
      {!isPitcher && hitting && (
        <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
          <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
            <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Batting — {label}</span>
          </div>
          <div className="p-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6">
            <div>
              <Row label="Batting Average" value={hitting.avg} highlight />
              <Row label="On-Base %" value={hitting.obp} />
              <Row label="Slugging" value={hitting.slg} />
              <Row label="OPS" value={hitting.ops} highlight />
              <Row label="wOBA" value={hitting.wOBA} note="Weighted on-base avg" />
            </div>
            <div>
              <Row label="Home Runs" value={hitting.homeRuns} />
              <Row label="RBI" value={hitting.rbi} />
              <Row label="Runs" value={hitting.runs} />
              <Row label="Stolen Bases" value={hitting.stolenBases} />
              <Row label="Strikeouts" value={hitting.strikeOuts} />
              <Row label="Walks" value={hitting.baseOnBalls} />
              <Row label="At Bats" value={hitting.atBats} />
              <Row label="Hits" value={hitting.hits} />
              <Row label="Doubles" value={hitting.doubles} />
              <Row label="Triples" value={hitting.triples} />
            </div>
          </div>
        </div>
      )}

      {isPitcher && pitching && (
        <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
          <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
            <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Pitching — {label}</span>
          </div>
          <div className="p-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6">
            <div>
              <Row label="ERA" value={pitching.era} highlight />
              <Row label="WHIP" value={pitching.whip} highlight />
              <Row label="Wins" value={pitching.wins} />
              <Row label="Losses" value={pitching.losses} />
              <Row label="Saves" value={pitching.saves} />
            </div>
            <div>
              <Row label="Strikeouts" value={pitching.strikeOuts} />
              <Row label="Innings Pitched" value={pitching.inningsPitched} />
              <Row label="Walks" value={pitching.baseOnBalls} />
              <Row label="Hits Allowed" value={pitching.hits} />
              <Row label="HR Allowed" value={pitching.homeRuns} />
              <Row label="K/9" value={pitching.strikeoutsPer9Inn} note="Strikeouts per 9 IP" />
              <Row label="BB/9" value={pitching.walksPer9Inn} />
              <Row label="H/9" value={pitching.hitsPer9Inn} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlayerMetricsSeasonStats;